import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { BODY, OLIVE } from './DagbladFrontPage';
import { todayYmd, CHANGED } from './ChoreBoard';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/chores`;
const SRC = 'kid-column';

export default function KidChores({ kid, onGotSticker }) {
  const [chores, setChores] = useState(kid.chores || []);
  useEffect(() => setChores(kid.chores || []), [kid.chores]);
  useEffect(() => {
    const on = (e) => {
      const { id, done, sticker, src } = e.detail;
      if (src === SRC) return;
      setChores((xs) => xs.map((x) => (x.id === id ? { ...x, done } : x)));
      if (sticker && sticker.kid_id === kid.id) onGotSticker(sticker);
    };
    window.addEventListener(CHANGED, on);
    return () => window.removeEventListener(CHANGED, on);
  }, [kid.id, onGotSticker]);
  if (!chores.length) return null;
  const toggle = async (c) => {
    const done = !c.done;
    setChores((xs) => xs.map((x) => (x.id === c.id ? { ...x, done } : x)));
    try {
      const { data } = await axios.post(`${API}/${c.id}/toggle`, { date: todayYmd(), done }, { withCredentials: true });
      window.dispatchEvent(new CustomEvent(CHANGED, { detail: { id: c.id, done, sticker: data.sticker, src: SRC } }));
      if (data.sticker && !data.sticker.removed) toast.success(`${data.sticker.emoji} ${kid.name} fick ett klistermärke för ${c.text.toLowerCase()}!`);
      if (data.sticker) onGotSticker(data.sticker);
    } catch {
      setChores((xs) => xs.map((x) => (x.id === c.id ? c : x)));
      toast.error('Kunde inte spara');
    }
  };
  return (
    <div className="mt-2" data-testid={`kidcol-${kid.id}-chores`}>
      <p className="text-[11px] font-black uppercase tracking-widest" style={{ color: OLIVE }}>🧽 {kid.name}s sysslor</p>
      <ul className="mt-1 space-y-1" style={{ fontFamily: BODY }}>
        {chores.map((c) => (
          <li key={c.id}>
            <button onClick={() => toggle(c)} className={`w-full flex items-center gap-2 text-left text-sm rounded-xl px-2 py-1.5 border-2 transition-colors ${c.done ? 'bg-[#E8F7D9] border-[#9BD27A] line-through opacity-70' : 'bg-[#FFF0F6] border-[#FFB3CF] hover:bg-white'}`}
              data-testid={`kidcol-chore-${c.id}`}>
              <span className="text-lg">{c.done ? '🌟' : '⬜'}</span>
              <span className="flex-1">{c.text}</span>
              {!c.done && <span className="text-[10px] font-black opacity-60">= klistermärke</span>}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
